import { CanActivateFn } from '@angular/router';
import { Router } from '@angular/router';
import { inject } from '@angular/core';

export const roleGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const expectedRoles = route.data['roles'] as string[];

  const userInfoString = localStorage.getItem('userInfo');
  if (!userInfoString) {
    // console.log('RoleGuard: No userInfo found. Redirecting.');
    router.navigate(['/unauthorized']);
    return false;
  }

  try {
    const userInfo = JSON.parse(userInfoString);
    const userRole = userInfo.userGroup;

    // console.log('RoleGuard: User Role:', userRole);
    // console.log('RoleGuard: Expected Roles:', expectedRoles);

    if (expectedRoles.includes(userRole)) {
      // console.log('RoleGuard: Access GRANTED.');
      return true;
    } else {
      // console.log('RoleGuard: Access DENIED. Redirecting.');
      router.navigate(['/unauthorized']);
      return false;
    }
  } catch (e) {
    // console.error('RoleGuard: Error parsing userInfo:', e);
    router.navigate(['/unauthorized']);
    return false;
  }
};
